import { takeLatest, call, put, select } from "redux-saga/effects";

import projectWizardUtils from "../reducers/projectWizard/projectWizardUtils.js";

import { createAction } from "../actions/actionUtils.js";
import { handleError } from "./apiSagas.js";
import { projectCreationSaga } from "./projectSagas.js";
import { resourceCreationSaga } from "./resourceSagas.js";
import { accountSaga } from "./accountSagas.js";
import { getEstimatesSaga } from "./estimateSaga.js";

import { getAccount } from "../reducers/account/accountActions.js";
import { resetErrors } from "../reducers/api/apiActions.js";
import { createViolationResponse } from "../reducers/api/createViolationResponse.js";

import { PROJECT_WIZARD } from "../reducers/projectWizard/projectWizardConstants.js";
import { ESTIMATES } from "../actions/actionConstants.js";

// -- PROJECT CREATION -- //

function* wizardCreateSaga(action) {
  const { projectId, name } = action.payload;

  // augment action payload
  action.payload = projectWizardUtils.buildProjectCreationData(
    yield select(),
    action.payload,
    action.id
  );

  // reset the error store to clear any previous submissions
  yield put(resetErrors());

  try {
    if (projectId) {
      // we have a project we just need to create resources
      yield call(resourceCreationSaga, action);
      // using direct saga call rather than put so we can be sure it returns
      yield call(accountSaga, undefined, getAccount());
      yield put(createAction(PROJECT_WIZARD.POST_COMPLETE));
    } else if (name) {
      // we are creating a project from scratch
      const project = yield call(projectCreationSaga, action);
      // using direct saga call rather than put so we can be sure it returns
      yield call(accountSaga, undefined, getAccount());
      yield put(createAction(PROJECT_WIZARD.POST_COMPLETE, project));
    } else {
      // we don't have a valid creation route
      const error = createViolationResponse([
        {
          propertyPath: "details",
          message: "A valid project name or projectId is required"
        }
      ]);
      yield call(handleError, error, action, true, false);
      yield put(createAction(PROJECT_WIZARD.FAILURE));
    }
  } catch (error) {
    yield put(createAction(PROJECT_WIZARD.FAILURE));
  }
}

function* wizardResetSaga(action) {
  // wizard store reset already managed by the action that triggers this saga
  yield put(createAction(ESTIMATES.RESET));
}

// -- WATCHERS -- //

export function* watchProjectWizardSagas() {
  yield takeLatest(PROJECT_WIZARD.UPDATE_ESTIMATE, getEstimatesSaga);
  yield takeLatest(PROJECT_WIZARD.POST, wizardCreateSaga);
  yield takeLatest(PROJECT_WIZARD.RESET, wizardResetSaga);
}
